import Router from "./routes/Router";

function App() {
// console.log('LIVE CODE: 03 Septpember 2026');
  return (
    <>
      <Router />
    </>
  );
}

export default App;
